import request from './request.js'

export function getIdList() {
  return request({
    url: `/get-id-list`,
    method: 'get',
    data: {  }
  })
}


export function updateServicesAndSync(servicesMap, lang, servicesDetail, detailSign ) {
  return request({
    url: `/services-sync`,
    method: 'post',
    data: {servicesMap,lang, servicesDetail, detailSign},
  })
}

export function updateContactAndSync(contact, idList, lang) {
  return request({
    url: `/contact-sync`,
    method: 'post',
    data: { contact , idList, lang},
  })
}

export function getCurrentMid() {
  return request({
    url: `/current-mid`,
    method: 'get',
    data: {  }
  })
}

export function getLastSelectedDepts(){
  return request({
    url: `/get-last-selected-depts`,
    method: 'get',
    data: {  }
  })
}

export function getDeptData(){
  return request({
    url: `/get-dept-data`,
    method: 'get',
    data: {  }
  })
}

export function getAddressData(){
  return request({
    url: `/address-data`,
    method: 'get',
    data: {  }
  })
}

export function checkRelation(rid) {
  return request({
    url: `/check-relation`,
    method: 'post',
    data: {  rid }
  })
}

export function qualifyMid(){
  return request({
    url: `/qualify`,
    method: 'get',
    data: {   }
  })
}


export function validateAddress(address) {
  return request({
    url: `/validate-address`,
    method: 'post',
    data: {  address }
  })
}

export function isRegistered() {
  return request({
    url: `/is-registered`,
    method: 'get'    
  })
}

export function enquiry(id) {
  return request({
    url: `/enquiry`,
    method: 'get', 
    params: {
      id: id
    }   
  })
}

export function queryAuthorizationUrl(id, lang) {
  return request({
    url: `/query-authoriztion-url`,
    method: 'get', 
    params: { lang }   
  })
}



export function queryPageData(dept, lang) {
  return request({
    url: `/query-page-data`,
    method: 'post', 
    data: { dept, lang }   
  })
}

export function queryDetailData(depts, lang) {
  return request({
    url: `/query-detail-data`,
    method: 'post', 
    data: { depts, lang }   
  })
}
